import { render, staticRenderFns } from "./ems.vue?vue&type=template&id=299fd010&scoped=true"
import script from "./ems.vue?vue&type=script&lang=js"
export * from "./ems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299fd010",
  null
  
)

export default component.exports